// This component has completely been modified and Accordion is removed for the transport histories screen design by Bearer Web Developer
import React from "react";
import ReceiveReceiptPopup from "./ReceiveReceiptPopup";
import { observer } from "mobx-react-lite";
import { TTransportsHistoryInfo } from "../../api/bearer-api";
// import TransportRouteMap from "./TransportRouteMap"; // the name modified by Bearer Web Developer and commented by Bearer Web Developer - change map api
import ShowImage from "../showImage/ShowImage";
import styles from './TransportHistoryDetail.module.scss'; // added by Bearer Web Developer
import { useThemeMode } from "../../states/contexts/theme"; // added by Bearer Web Developer
import TransportRouteMapApi from "./TransportRouteMapApi"; // added by Bearer Web Developer - change map api
// useStyles removed by Bearer Web Developer

interface ITransportHistoryDetailProps { transportsHistory: TTransportsHistoryInfo }
const TransportHistoryDetail: React.FC<ITransportHistoryDetailProps> = observer(({ transportsHistory }) => {

    const riding = transportsHistory.assigned_bearer_type === "riding";
    const driving = transportsHistory.assigned_bearer_type === "driving"; // added by Bearer Web Developer
    const { theme } = useThemeMode(); // added by Bearer Web Developer
    // modified by Bearer Web Developer start
    // expanded state and openHandler function and Accordion removed by Bearer Web Developer
    return (
        <div className={styles.more_details_part} data-theme={theme}> {/* data-theme property added by Bearer Web Developer */}
            <div className={styles.map_style}>
                <TransportRouteMapApi transportHistoryInfo={transportsHistory} /> {/* added by Bearer Web Developer - change map api */}
                {/* <TransportRouteMap transportHistoryInfo={transportsHistory} /> */} {/* commented by Bearer Web Developer - change map api */}
            </div>
            <div className={styles.more_details}>
                <div className={styles.rider_image}>
                    <div className={styles.image}>
                        <ShowImage fireBaseUrl={transportsHistory.rider_avatar_url} />
                    </div>
                    <p>{transportsHistory.rider_given_name} {transportsHistory.rider_last_name}</p>
                </div>
                <div className={styles.rider_details}>
                    {riding &&
                        <div className={styles.riding}>
                            <div className={styles.motorbike_registration}>
                                <h6>{transportsHistory.motorbike_registration_number}</h6>
                                <p>{transportsHistory.motorbike_registration_state}</p>
                            </div>
                            <h6 className={styles.motorbike_model}>{transportsHistory.motorbike_make} {transportsHistory.motorbike_model}</h6>
                        </div>
                    }
                    {/* added by Bearer Web Developer start */}
                    {driving &&
                        <div className={styles.driving}>
                            <div className={styles.car_registration}>
                                <h6>{transportsHistory.car_registration_number}</h6>
                                <p>{transportsHistory.car_registration_state}</p>
                            </div>
                            <h6 className={styles.car_model}>{transportsHistory.car_make} {transportsHistory.car_model}</h6>
                        </div>
                    }
                    {/* added by Bearer Web Developer end */}
                </div>
            </div>
            {
                transportsHistory?.transport_receivable_price !== 0 &&
                <div className={styles.receivable_price}>
                    <ReceiveReceiptPopup transportsHistory={transportsHistory} />
                </div>
            }
        </div>
    )
    // modified by Bearer Web Developer end
})
export default TransportHistoryDetail;
